import React, { useState } from "react";
import { useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form"
import { useParams } from 'react-router-dom';

//import axios from 'axios';
import axios_api from "../../Api";

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../../Context';


export function DocumentForm ({documentFilename, orderId}) {
  const [documentFileSelected, setDocumentFileSelected] = useState(false);
  //const media_url = useContext(MEDIA_URL);
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const navigate = useNavigate();
  const [formError, setFormError] = useState(false)

  //orderId = orderId;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });


  //console.log(orderId)

  const onSubmit = (fileData) => {

    let params = {'operation': 'update-main-docs'};
    let data = {...fileData, ...params};

    //console.log(data);

    
    axios_api.put(api_url + `/manage_order/` + orderId, data, {
      //paramsSerializer: { indexes: null },
      headers: {
        "Authorization": token, 
        "Content-Type": "multipart/form-data",
      }
    })
    .then(
      (result) => {
        console.log("Document uploaded");
        navigate("/order/" + orderId);
        navigate(0);
      },
      (error) => {
        setFormError(error.response.data)
        console.log(error);
      }
    );
  }


  return (
    <>
    <div className="lk-form">
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <div className="input-group mt-3">
          <label className="">
            <p>Приложите скан документа в формате pdf</p>
            <input type="file" className="form-control" style={{width: '400px'}} {...register(documentFilename)} onChange={(e) => setDocumentFileSelected(true)}/>
          </label>
        </div>
        <p className="text-secondary mt-1"><small>максимальный размер файла 10 мб</small></p>
        { formError &&
          <p className="text-danger">{formError}</p>
        }
        {(documentFileSelected === true) ?
          <button 
            type="submit" 
            className="btn lk-button my-3" 
            onClick={() => {handleSubmit(onSubmit)}}>
              Отправить документ
          </button>
        :
          <button type="button" className="btn lk-button my-3" disabled>Отправить документ</button>
        }
      </form>
    </div>
    </>  
  )
}